import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RoleState } from '@store/reducers';

export const selectRoleState = createFeatureSelector<RoleState>('role');

export const selectRoleLoading = createSelector(
  selectRoleState,
  (state: RoleState) => state.loading
);

export const selectRoleEditMode = createSelector(
  selectRoleState,
  (state: RoleState) => state.editMode
);

export const selectRoleIsEditing = createSelector(
  selectRoleState,
  (state: RoleState) => state.isEditing
);

export const selectRoleId = createSelector(
  selectRoleState,
  (state: RoleState) => state.roleId
);

export const selectRole = createSelector(
  selectRoleState,
  (state: RoleState) => state.role
);

export const selectRoleList = createSelector(
  selectRoleState,
  (state: RoleState) => state.roleList
);

export const selectRoleForm = createSelector(
  selectRoleState,
  (state: RoleState) => state.roleForm
);

export const selectRoleFormValid = createSelector(
  selectRoleState,
  (state: RoleState) => state.formValid
);

export const selectRoleInmutable = createSelector(
  selectRoleState,
  (state: RoleState) => state.roleInmutable
);

export const selectRoleError = createSelector(
  selectRoleState,
  (state: RoleState) => state.error
);